@let details = signUpDetails();

@if(details?.mentorSchedule; as schedule){
<schedule-viewer-part [selectedSlots]="schedule.selectedMeetingSlots" [numMeetings]="schedule.numMeetings" [timeZoneId]="details.standardFourTimeZoneId">
</schedule-viewer-part>
} @else {
<common-message alertType='warning'>
	No Schedule added for this Volunteer, edit ability coming soon!
</common-message>
}